.aircall-widget-container {
    position: relative;
    display: flex;
    align-items: center;
}

.aircall-workspace {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    z-index: 100;
}

.aircall-workspace-expanded {
    opacity: 1;
    transform: translateY(0) scale(1);
    pointer-events: auto;
    transition:
        opacity 160ms ease,
        transform 160ms ease;
}

.aircall-workspace-collapsed {
    width: 0;
    height: 0;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    transition: opacity 160ms ease;
}
